import { useMemo } from 'react';

// eslint-disable-next-line @atlassian/tangerine/import/no-restricted-paths

var MIN_INPUT_CHAR_LENGTH = 1;
export var useArticleSearch = function useArticleSearch(searchResponse, queryWord) {
  var _searchResponse$helpO3;
  var entities = useMemo(function () {
    var _searchResponse$helpO;
    return (searchResponse === null || searchResponse === void 0 || (_searchResponse$helpO = searchResponse.helpObjectStore_searchArticlesForSupportSite) === null || _searchResponse$helpO === void 0 ? void 0 : _searchResponse$helpO.edges) || [];
  }, [searchResponse === null || searchResponse === void 0 ? void 0 : searchResponse.helpObjectStore_searchArticlesForSupportSite]);
  var hasQueryError = Boolean(entities.find(function (edge) {
    var _edge$node;
    return edge === null || edge === void 0 || (_edge$node = edge.node) === null || _edge$node === void 0 ? void 0 : _edge$node.message;
  }));
  var articlesAndFolders = useMemo(function () {
    var _searchResponse$helpO2;
    var edges = (_searchResponse$helpO2 = searchResponse.helpObjectStore_searchArticlesForSupportSite) === null || _searchResponse$helpO2 === void 0 ? void 0 : _searchResponse$helpO2.edges;
    if (edges) {
      var resultItems = edges.map(function (_ref) {
        var node = _ref.node;
        var id = node.id,
          title = node.title,
          contentType = node.contentType,
          urlInfo = node.urlInfo;
        if (id && title && contentType && urlInfo !== null && urlInfo !== void 0 && urlInfo.shareUrl) {
          return {
            id: id,
            title: title,
            type: contentType.toString(),
            url: urlInfo.shareUrl
          };
        }
        return null;
      }).filter(function (item) {
        return item !== null;
      });
      return resultItems;
    }
    return undefined;
  }, [(_searchResponse$helpO3 = searchResponse.helpObjectStore_searchArticlesForSupportSite) === null || _searchResponse$helpO3 === void 0 ? void 0 : _searchResponse$helpO3.edges]);
  if (queryWord.length < MIN_INPUT_CHAR_LENGTH) {
    return {
      articlesAndFolders: undefined,
      hasQueryError: false
    };
  }
  return {
    articlesAndFolders: articlesAndFolders,
    hasQueryError: hasQueryError
  };
};